export class RoutePaths {
  public static readonly ROOT = "/";
}



// WEBPACK FOOTER //
// ./app/config/routePaths.ts